//import { get } from 'lodash';
export const convertDataFromServer = (res) => {
  const {
    customerDBMetaInfo,
    enableMobileRegistration,
    enableEmailRegistration,
    enableThirdPartyLoginRegistration,
    visibilityPolicy,
    enableOnlyVisibleAfterLogin,
    backgroundImage,
    enableLoginRemarks,
    loginRemarks,
    customerInfoFormSetting,
    customerInfoFields = [],
    termConditions = [],
    availableTermConditions = [],
    predefinedCustomerFields = [],
    passwordFormat,
    login2FA,
    ...rest
  } = res;
  //info
  // const customerDBMetaInfo = get(res, 'customerDBMetaInfo');
  //methods
  // const enableMobileRegistration = get(res, 'enableMobileRegistration');
  // const enableEmailRegistration = get(res, 'enableEmailRegistration');
  //   const enableThirdPartyLoginRegistration = get(
  //     res,
  //     'enableThirdPartyLoginRegistration',
  //   );
  //  const visibilityPolicy = get(res, 'visibilityPolicy');
  // const enableOnlyVisibleAfterLogin = get(res, 'enableOnlyVisibleAfterLogin');
  // const backgroundImage = get(res, 'backgroundImage');
  // const enableLoginRemarks = get(res, 'enableLoginRemarks');
  // const loginRemarks = get(res, 'loginRemarks');
  // const customerInfoFormSetting = get(res, 'customerInfoFormSetting');
  // const customerInfoFields = get(res, 'customerInfoFields', []) || [];
  // const termConditions = get(res, 'termConditions', []) || [];
  //const termConditionList = get(res, 'availableTermConditions', []) || [];
  //   const predefinedCustomerFields = (
  //     get(res, 'predefinedCustomerFields', []) || []
  //   ).map((i) => i.field);
  // const passwordFormat = get(res, 'passwordFormat', {});
  // const login2FA = get(res, 'login2FA', {});

  return {
    customerDBMetaInfo,
    method: {
      enableMobileRegistration,
      enableEmailRegistration,
      enableThirdPartyLoginRegistration,
    },
    publicAccess: {
      backgroundImage,
    },
    registration: {
      customerInfoFormSetting,
      customerInfoFields: customerInfoFields || [],
    },
    termConditions: termConditions || [],
    termConditionList: availableTermConditions || [],
    predefinedCustomerFields: predefinedCustomerFields || [],
    passwordFormat,
    login2FA,
    enableLoginRemarks,
    loginRemarks: loginRemarks || '登录发现更多精彩',
    visibilityPolicy,
    enableOnlyVisibleAfterLogin,
    ...rest,
  };
};
